const Card = ({
  children,
  containerStyle = "bottom-0 right-0 h-auto w-auto",
  bodyClassNames = "px-3 py-3",
  testId = "",
}) => {
  return (
    <div
      className={`absolute rounded shadow-md m-8 bg-white z-40 ${containerStyle}`}
      data-testid={`card-${testId}-test`}
    >
      <div className="max-w-sm">
        <div className={`${bodyClassNames}`}>{children}</div>
      </div>
    </div>
  );
};

export default Card;
